export enum PasswordSubmitMethod {
  WorkEmail = 'workEmail',
  SMS = 'mobile',
  AlternateEmail = 'alternateEmail',
}

export type PasswordSubmitMethodFormFields = {
  method: PasswordSubmitMethod;
  workEmail?: string;
  alternateEmail?: string;
  mobile?: string;
};
